 function fetchJsonAndDisplay() {
            //const locale = navigator.language; // Get user's browser locale
           // const url = `https://czokindustries.com/get/shopWizzard/allesEbikeWizzardJson.json`;
          //  const url = "/assets/allesEbikeWizzardJson.json";
            const url = window.selector_json_url;

            fetch(url)
            .then(response => response.json())
            .then(jsonData => {
                fillOptions(jsonData.SectionContent.GridElementsArray);
                updatewizzard_question(jsonData.SectionContent.title);
            })
            .catch(error => {
                console.error('Error fetching JSON:', error);
                document.getElementById('wizzard_question').innerText = "Error loading content.";
            });
        }

        function fillOptions(gridElementsArray) {
            var optionsDiv = document.getElementById('options');
            optionsDiv.innerHTML = ""; // Clear previous content

            gridElementsArray.forEach(function(item) {
                var text = item.text ? item.text : "";
                optionsDiv.innerHTML += `<div onclick='myFunction(${JSON.stringify(item)})' class='panel'><img class='logo' src='${item.imageSource}' alt=''><p id='label'>${text}</p></div>`;
            });
        }

        function myFunction(item) {
            if (item.target === "ReturnAction") {
                goBack();
            } else if (typeof item.target === 'string') {
                window.location.href = item.target;
            } else if (item.target && item.target.SectionContent && item.target.SectionContent.GridElementsArray) {
                fillOptions(item.target.SectionContent.GridElementsArray);
                updatewizzard_question(item.target.SectionContent.title);
            }
            updateScrollPosition();
        }

        function updateScrollPosition(){
            //Scroll back up to the top of the section
            //document.getElementById('wizzard_banner').scrollIntoView({ behavior: 'auto' });
            //window.scrollTo({ top: 0, behavior: 'auto' });

            // Get the position of the wizzard_banner element
            const banner = document.getElementById('wizzard_banner');
            const rect = banner.getBoundingClientRect();
    
            // Calculate the position 30 pixels above the element
            const scrollPosition = window.pageYOffset + rect.top - 40;

            // Scroll to the calculated position
            window.scrollTo({ top: scrollPosition, behavior: 'auto' });
        }

        function updatewizzard_question(title) {
            document.getElementById('wizzard_question').innerHTML = title;
        }

        function goBack() {
            fetchJsonAndDisplay(); // Reload the initial JSON to simulate "go back"
        }

        document.addEventListener('DOMContentLoaded', fetchJsonAndDisplay); // Fetch JSON when the document is ready